import React from 'react';
import { motion } from 'framer-motion';
export function GallerySection() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/9FViNuEXQAEaWy1qFVrn83/y4.png',
    alt: 'Pohled na budovu z ulice',
    className: 'col-span-1 md:col-span-2 aspect-[21/9]',
    index: 0
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/cv1wtq2fqZCj6hSXE5Te1E/y5.png',
    alt: 'Detailní pohled na balkony',
    className: 'col-span-1 aspect-[4/3]',
    index: 1
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/dFfdPhD6t68BCbFttac4wK/y14.png',
    alt: 'Pohled do vnitrobloku',
    className: 'col-span-1 aspect-[4/3]',
    index: 2
  }];
  return <section id="galerie" className="py-24 bg-white" data-id="element-119">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-121">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-122">
            Galerie
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-123">
            Prohlédněte si vizualizace vašeho budoucího domova
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-124">
          {images.map((img, index) => <motion.div key={img.index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative group overflow-hidden rounded-xl cursor-pointer ${img.className}`} onClick={() => {
          window.location.hash = `#cela-galerie?image=${img.index}`;
        }} data-id="element-125">
              <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-126" />
              <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-127">
                <span className="text-white font-medium tracking-wider uppercase border border-white/50 px-6 py-2 rounded-sm backdrop-blur-sm" data-id="element-128">
                  Zobrazit
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-129">
          <a href="#cela-galerie" className="inline-block bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-130">
            Zobrazit celou galerii
          </a>
        </motion.div>
      </div>
    </section>;
}